<template>
  <Modal ref="Modal" :show="show" @close="cancel()" :showDivider="!$media('md')">
    <template v-slot:header>
      <div
        class="ds-text-base font-bold text-gray-1000 md:-mb-6"
        data-test-id="recommendation-title"
      >Request Recommendation</div>
    </template>

    <template v-slot:body>
      <!-- Negative margin is a hack to undo the empty header pushing the body down. -->
      <!-- Let's handle this better when we get a chance. -->

      <div class="flex flex-col h-full md:-mt-6">
        <div class="ds-text-sm font-normal text-gray-700">
          Edit the message below and we'll send it to {{ athleteName }}'s coaches on your behalf.
          This request will not be visible to the athlete.
        </div>

        <textarea
          v-model="messageBody"
          class="border-1 border-solid border-gray-300 text-base text-gray-900 rounded px-3 py-2 my-4 w-full md:h-64"
          style="flex-grow: 1"
          data-test-id="recommendation-message-body"
        />
      </div>
    </template>

    <template v-slot:actions>
      <div class="bg-white flex justify-end md:p-0">
        <Button
          :short="true"
          text="Cancel"
          color="red"
          emphasis="low"
          class="flex-1 md:flex-none mr-2"
          data-test-id="cancel-button"
          @click="cancel()"
        />
        <Button
          :short="true"
          class="flex-1 md:flex-none"
          text="Send Request"
          data-test-id="send-button"
          @click="confirm()"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@sportsrecruits/playbook';
import { Button } from '@sportsrecruits/playbook';

export default {
  components: { Modal, Button },

  props: {
    value: { type: String, required: true },
    show: { type: Boolean, default: true },
    athleteName: { type: String, required: true }
  },

  computed: {
    messageBody: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      }
    }
  },

  methods: {
    confirm() {
      this.$emit("confirm");
      this.$emit("close");
    },

    cancel() {
      this.$emit("cancel");
      this.$emit("close");
    }
  }
};
</script>